import { Box } from '@mui/material'
import { MondayIframe } from './components/MondayIframe'

export const Home = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <MondayIframe />
    </Box>
  )
}
